import React, { useEffect, useState } from "react";
import ProductLists from "../features/products/ProductLists";

const FavouriteProductPage = ({ setFormData }) => {
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const [searchValues, setSearchValues] = useState({
    Product_Code: "",
    Product_Name: "",
  });

  useEffect(() => {
    // Load favorite products from local storage
    const storedFavorites = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavoriteProducts(storedFavorites);
  }, []);

  const handleRemoveFavorite = (id) => {
    const updatedFavorites = favoriteProducts.filter((item) => item.id !== id);
    setFavoriteProducts(updatedFavorites);
    localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
  };

  // Filter favorite products based on the search values
  const filteredProducts = favoriteProducts.filter((product) => {
    return (
      product.Product_Name.toLowerCase().includes(
        searchValues.Product_Name.toLowerCase()
      ) &&
      product.Product_Code.toLowerCase().includes(
        searchValues.Product_Code.toLowerCase()
      )
    );
  });

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Favorite Products</h1>
      <ProductLists
        products={filteredProducts}
        isLoading={false}
        searchValues={searchValues}
        setSearchValues={setSearchValues}
        setFormData={setFormData}
        handleRemoveFavorite={handleRemoveFavorite}
      />
    </div>
  );
};

export default FavouriteProductPage;
